import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-two-col-area-no-button',
  templateUrl: './two-col-area-no-button.component.html',
  styleUrls: ['./two-col-area-no-button.component.css']
})
export class TwoColAreaNoButtonComponent implements OnInit {

  @Input() twoColAreaNoButtonItems: any = {}



  constructor() { }

  ngOnInit(): void {

  }

}
